import React, { useState, useEffect } from "react";
import RelatedDetailCard from '../../components/products/relateddetails';
import VehicleData from '../../assets/data/vehile';
import Loader from '../../components/loaders/loader3';


function RelatedDetailsCard() {
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); 

    return () => clearTimeout(timer); 
  }, []);

  if (loading) {
    return <Loader />; 
  }
  return (
    <div>
        {
          VehicleData.map((vehicle)=>{
            return <RelatedDetailCard
             key={vehicle._id} 
             title={vehicle.title}
             price={vehicle.price}
             SlideImages={vehicle.SlideImages}
             negotiable={vehicle.negotiable}
             engin={vehicle.engin}
             fuel={vehicle.fuel}
             location={vehicle.location}
             description={vehicle.description}
             model={vehicle.model}
             year={vehicle.year}
             mileage={vehicle.mileage}
             transmission={vehicle.transmission}
             condition={vehicle.condition}
             color={vehicle.color}
             features={vehicle.features}
             contact={vehicle.contact}
             MainImage={vehicle.MainImage}
              />
          })
        }
    </div>
  )
}

export default RelatedDetailsCard